

function doubleBackButton() {

	var formStepInput = document.querySelector('#formStep');

	var contactBackLink = document.querySelector('.contact-wiz-back-link');
	var formsBackLink = document.querySelector('.umbraco-forms-page .back-link');

	if (formStepInput != null) {

		var currentFormStep = formStepInput.value;
		
		// hide any forms back links on the first page and show the wiz back link
		if (contactBackLink != null && currentFormStep == 0) {

			if (formsBackLink != null)
				formsBackLink.style.display = 'none';

			contactBackLink.style.display = 'block';
		}

		// hide any wiz back link and show forms back link on subsequent pages
		if (contactBackLink != null && currentFormStep > 0) {

			if (formsBackLink != null)
				formsBackLink.style.display = 'block';

			contactBackLink.style.display = 'none';
		}

		

	} else {

		// any wizard back links, show it
		if (contactBackLink != null)
			contactBackLink.style.display = 'block';
	}
}

if (document.readyState !== 'loading') {
	doubleBackButton();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		doubleBackButton();
	});
}